import React from 'react';
import '../css/main.css';
import '../css/reset.css';
import NAVIGATIONBAR from '../Components/Login/navigationBar';
import LOGINFORM from '../Components/Login/loginForm';
import NEWSTAB from '../Components/Login/newsTab';
import { useCookies } from 'react-cookie';
import { useEffect, useState } from 'react';
import LIFFLOGIN from '../Components/Login/LiffloginForm';
import liff from '@line/liff';

interface EnvType {
  REACT_APP_LIFF_APP_ID: string;
}
interface Profile {
  userId: string;
  displayName: string;
  pictureUrl?: string;
  statusMessage?: string;
}

const Login = () => {
  const [isLiffInitialized, setIsLiffInitialized] = useState(false);
  const [profile, setProfile] = useState<Profile | null>(null);
  const [lineToken, setLineToken] = useState<string | null>(null);
  const [idToken, setIdToken] = useState<any | null>(null);
  const [cookies, setCookie] = useCookies(['authority', 'access_token', 'idToken', 'siteId', 'siteRecno']);
  const env = process.env as unknown as EnvType;
  const liff_id = env.REACT_APP_LIFF_APP_ID;

  const userAgent = navigator.userAgent;
  const isFromLINE = /Line\/[0-9.]+/.test(userAgent);

    useEffect(() => {
      async function initializeLiff() {
        if(!isFromLINE) return;

        try {
          await liff.init({ liffId: liff_id });
          setIsLiffInitialized(true);

          const token = liff.getAccessToken();
          setLineToken(token);

          const userProfile = await liff.getProfile();
          setProfile(userProfile);

          const idToken = liff.getIDToken();
          setIdToken(idToken);
          setCookie('idToken', idToken, { path: '/', maxAge: 3600 });

          liff.login();
        } catch (error) {
          console.error('LIFF initialization failed:', error);
        }
      }
      initializeLiff();
    }, [idToken]);

  return (
    <>
      <div className="wrapper">
        <NAVIGATIONBAR />
        <main className="login-main">
          {isFromLINE ? <LIFFLOGIN /> : <LOGINFORM />}
          <NEWSTAB />
        </main>
      </div>
    </>
  )
};

export default Login;
